import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-idle-candidate',
  templateUrl: './idle-candidate.component.html',
  styleUrls: ['./idle-candidate.component.scss']
})
export class IdleCandidateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
